export default Buffer.from("A+BSQ29weXJpZ2h0IDE5OTAtMjAwOSBBZG9iZSBTeXN0ZW1zIEluY29ycG9yYXRlZC4KQWxsIHJpZ2h0cyByZXNlcnZlZC4KU2VlIC4vTElDRU5TReELS1NDLUpvaGFiLUhhENkyAb54AQC+egAAwQACAr57AQC+fgQLvn8tAL8LgTUAvwwGAb8NAgC/DwEAvxALBb8RGwC/FwEAvxgBAL8ZLQO/Gg==", "base64")


//////////////////
// WEBPACK FOOTER
// ./~/vue-pdf-signature/src/buffer-loader.js!./~/pdfjs-dist-sign/cmaps/KSC-Johab-V.bcmap
// module id = 672
// module chunks = 502